import React, { ChangeEvent, useCallback, useState } from 'react'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'

export const FileInput = React.forwardRef<HTMLInputElement, Props>(({ image , label , ...props }, ref) => {
    
    const [fileName,setFileName] = useState<string>("")

    const handleChange = useCallback((e:ChangeEvent<HTMLInputElement>)=>{
        const files = e.currentTarget?.files
        if(files)
          setFileName(files[0].name)
      },[])
    return (
            <>
            <div className='font-semibold col-span-3 -mb-3'>{label}</div>
            <div className='col-span-2 pr-2'>
                <TextInput className="rounded-md bg-gray-100 border-gray-500" defaultValue={fileName ? fileName : ""}/>
                <input type={'file'} id={image ? 'image-input' : 'file-input'} name={image? "image" : "pdf"} {...props} className="hidden" onChange={handleChange}/>
            </div>
            <div className='flex items-center'>
            <label className='col-span-1 bg-primary p-2 rounded-md' htmlFor={image ? 'image-input' : 'file-input'}>
                Buscar {image ? 'Imagem' : "Arquivo"}
            </label>
            </div>
            </>
     
    )
})
interface Props {
    label?:string
    image?:boolean
    
}